import { Typography, Divider } from '@mui/material';

const MultiTooltipContent = ({ events }) => {
  return (
    <div>
      {events.map((e, idx) => {
        const task = e?.eventData;
        return (
          <div key={e.id}>
            {idx > 0 && <Divider sx={{ my: 1 }} />}
            <div className="flex justify-between">
              <Typography fontWeight="bold">Feladat:</Typography>
              <Typography textAlign="right">{task?.name ?? 'N/A'}</Typography>
            </div>
            <div className="flex justify-between">
              <Typography fontWeight="bold">Felelős:</Typography>
              <Typography>{task?.responsiblePerson?.nickName ?? 'N/A'}</Typography>
            </div>
            <div className="flex justify-between">
              <Typography fontWeight="bold">Csoport:</Typography>
              <Typography>{task?.userGroup?.name ?? 'N/A'}</Typography>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default MultiTooltipContent;
